module.exports = __webpack_public_path__ + "static/media/signal-3.e326a83c.svg";